// extracted by mini-css-extract-plugin
export default {"thumbnail":"TrackInfo_thumbnail__5MCCh","thumbnailSkeleton":"TrackInfo_thumbnailSkeleton__RPEe-","link":"TrackInfo_link__6G4CL"};